
import React, { useContext, useState } from 'react'
import { StoreContextMain } from '../../../Context/StoreContextMain'
import { CiShoppingCart } from 'react-icons/ci'
import { alertDialog, alertError, alertToast } from '../../../Helpers/Alerts'
import { useChekingAuth } from '../../../Auth'
import { useNavigate } from 'react-router-dom'


export const BtnAddCar = ({ id, title, description, price, image, text_aditional = '' }) => {

  const { store, setStore, selectedCharacteristics : feature } = useContext(StoreContextMain)
  
  const { logged } = useChekingAuth();

  const navigate = useNavigate()

  const [stateAdd, setStateAdd] = useState(false);

  const addCar = () => {
    if(!logged) return alertDialog('Primero necesitas iniciar sesión o registrarte', 'Ir', 'Cancelar').then(res => res ? navigate('/my-account') : false)

    if (id === null || id === '' || id === undefined) return alertError('Producto no disponible', 'No se ha encontrado el producto disponible');

    let color = feature.color ?? null
    let size = feature.size ?? null
    let amount = feature.amount ?? null
    let amount_max = feature.amount_max ?? null

    if (color === null || color === '') return alertError('Seleciona el color', 'No se ha selecionado el color');
    if (size === null || size === '') return alertError('Seleciona el tamaño', 'No se ha seleccionado el tamaño');
    if (amount === null || amount === 0) return alertError('Seleciona la cantidad', 'No se ha selecionado la cantidad');
    console.log({id, title, price, image, color, size, amount, amount_max})
    // if (store.find(item => item.id === id)) return
    setStore([...store, {id, title, price, image, color, size, amount, amount_max}])
    setStateAdd(!stateAdd)
    alertToast('Se agrego al carrito.', 'success', 'start', 3000)
  }

  return (
    <button
        className={`car  ${text_aditional && 'd-flex btn btn-primary '}`}
        onClick={addCar}
    >
        <CiShoppingCart
          size={'2rem'}
          className={text_aditional && 'me-2'}
          style={{ color: stateAdd ? 'green' : 'var(--cafe-oscuro)'}}
        />
        {text_aditional}
    </button>
  )
}

